import fetch from 'isomorphic-fetch'

import {
  FETCH_PAGE_CONTENT,
  FETCH_PAGE_CONTENT_FULFILLED,
  FETCH_PAGE_CONTENT_REJECTED,
  FETCH_PAGE_PROMO_CONTENT,
  FETCH_PAGE_PROMO_CONTENT_FULFILLED,
  FETCH_PAGE_PROMO_CONTENT_REJECTED,
  SAVE_LIVE_CHAT_STATUS,
  SET_CHAT_MINIMIZED,
  SET_CHAT_ENDED,
  TOGGLE_CHAT
} from './types'

export function fetchPageContent (pageId, fromServer = false) {
  const errorMessage = 'Bad response from server'
  let url = fromServer ? 'http://127.0.0.1:3000/helpfaq-assets/static/data/pages/' : '/helpfaq-assets/static/data/pages/'
  return dispatch => {
    dispatch(beginPageContent())
    return fetch(url + pageId + '.json')
      .then(response => {
        if (response.status >= 400) {
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(result => {
        return dispatch(retrievePageContent(result))
      })
      .catch(error => {
        return dispatch(errorPageContent(error))
      })
  }
}

export function beginPageContent (result) {
  return {
    type: FETCH_PAGE_CONTENT
  }
}

export function retrievePageContent (result) {
  return {
    type: FETCH_PAGE_CONTENT_FULFILLED,
    payload: result
  }
}

export function errorPageContent (error) {
  return {
    type: FETCH_PAGE_CONTENT_REJECTED,
    payload: error
  }
}

export function fetchPagePromoContent (pageId, fromServer = false) {
  const errorMessage = 'Bad response from server'
  let url = fromServer ? 'http://127.0.0.1:3000/helpfaq-assets/static/data/pages/' : '/helpfaq-assets/static/data/pages/'
  return dispatch => {
    dispatch(beginPagePromoContent())
    return fetch(url + 'promo-' + pageId + '.json')
      .then(response => {
        if (response.status >= 400) {
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(results => {
        return dispatch(retrievePagePromoContent(results))
      })
      .catch(error => {
        return dispatch(errorPagePromoContent(error))
      })
  }
}

export function beginPagePromoContent (result) {
  return {
    type: FETCH_PAGE_PROMO_CONTENT
  }
}

export function retrievePagePromoContent (results) {
  return {
    type: FETCH_PAGE_PROMO_CONTENT_FULFILLED,
    payload: results
  }
}

export function errorPagePromoContent (error) {
  return {
    type: FETCH_PAGE_PROMO_CONTENT_REJECTED,
    payload: error
  }
}

export function saveLiveChatStatus (status) {
  return {
    type: SAVE_LIVE_CHAT_STATUS,
    payload: status
  }
}

export function setChatMinimized (minimized) {
  return {
    type: SET_CHAT_MINIMIZED,
    payload: minimized
  }
}

export function setChatEnded (ended) {
  return {
    type: SET_CHAT_ENDED,
    payload: ended
  }
}

export function toggleChat (payload) {
  return {
    type: TOGGLE_CHAT,
    payload
  }
}
